import script from "./GoogleSignIn.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleSignIn.vue?vue&type=script&setup=true&lang=js"

import "./GoogleSignIn.vue?vue&type=style&index=0&id=632c06fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-632c06fa"]])

export default __exports__